<template>
  <v-container>
    <v-card
      class="align-center"
      width="450"
      height="100%"
      color="messageBubble"
      elevation="0"
      dark
    >
      <v-row justify="start" no-gutters dense>
        <v-col sm="6">
          <v-btn x-small outlined color="cleed_blue">
            <b>{{
              $t(`messanger.dash.msg_types.Attachment`) || "attachment"
            }}</b>
          </v-btn>
        </v-col>
      </v-row>
      <v-row justify="center" class="mt-1" v-if="message.attachment.text">
        <v-col cols="12" sm="11">
          <span class="black--text">{{ message.attachment.text }}</span>
        </v-col>
      </v-row>
      <v-divider
        color="#1141ce"
        class="mx-4 my-1"
        v-show="message.attachment.text"
      ></v-divider>
      <v-row no-gutters class="mt-3 ma-2 mb-6">
        <v-col cols="12">
          <v-row justify="center" align="center">
            <v-col cols="6" sm="6" v-for="(img, index) in looks" :key="index">
              <v-img
                @error="onImgError(img, index)"
                v-if="img.location"
                :src="img.location"
                :lazy-src="img.location"
                width="100%"
                aspect-ratio="1"
                :alt="img.originalname"
              />
              <v-img
                v-else
                src="@/assets/no-product.png"
                width="100%"
                aspect-ratio="1"
              />
            </v-col>
          </v-row>
        </v-col>
        <v-btn
          fab
          elevation="1"
          absolute
          right
          class="mt-2"
          bottom
          x-small
          color="cleed_blue"
          style="margin: 0px 0px -18px"
          :disabled="right"
          :light="right"
          @click="next()"
        >
          <v-icon>mdi-chevron-right</v-icon>
        </v-btn>
        <v-btn
          elevation="1"
          fab
          absolute
          left
          bottom
          class="mt-2"
          x-small
          color="cleed_blue"
          style="margin: 0px 0px -18px"
          :disabled="left"
          :light="left"
          @click="prev()"
        >
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </v-row>
    </v-card>
  </v-container>
</template>

<script>
export default {
  name: "Chat_message_attachment",
  props: {
    message: {
      type: Object,
      default: () => {},
    },
  },
  data: () => ({
    from: 0,
    to: 0,
    looks: [],
    left: false,
    right: false,
  }),
  created() {
    this.from = 0;
    this.to = 2;
    this.looks = this.message.attachment.values;
    this.diplay_mutiple();
    if (this.from - 2 <= 0) this.left = true;
  },
  methods: {
    diplay_mutiple() {
      this.looks = [];
      for (let i = this.from; i < this.to; i++) {
        const element = this.message.attachment.values[i];
        if (element) this.looks.push(element);
      }
      if (
        this.message.attachment.values &&
        this.message.attachment.values.length <= 2
      )
        this.right = true;
    },
    next() {
      if (
        this.message.attachment.values &&
        this.to + 2 >= this.message.attachment.values.length
      )
        this.right = true;
      this.from = this.to;
      this.to = this.from + 2;
      this.diplay_mutiple();
      this.left = false;
    },
    prev() {
      if (this.from - 2 <= 0) this.left = true;
      this.from = this.to - 4;
      this.to = this.from + 2;
      this.diplay_mutiple();
      this.right = false;
    },
    onImgError(item, i) {
      console.log({ item, i });
      this.looks[i].location = null;
    },
  },
};
</script>
<style scoped></style>
